import { BrowserRouter as Router } from "react-router-dom"
import { HelmetProvider } from 'react-helmet-async'
import Routing from './routes';
import './i18n';
import { getLangFromPath, basenameFor } from './i18n/lang.mjs'
import './assets/css/bootstrap.min.css'
import './assets/css/animate.min.css'
import './assets/css/magnific-popup.css'
import './assets/css//fontawesome-all.min.css'
import './assets/css/dripicons.css'
import './assets/css/slick.css'
import './assets/css/meanmenu.css'
import './assets/css/default.css'
import './assets/css/style.css'
import './assets/css/modern.css'
import './assets/css/responsive.css'

export default function App() {
  // Language (and therefore the router basename) is derived from the URL prefix:
  // '' for sr, '/en', '/de'. Every existing <Link to="/x"> then resolves
  // relative to this basename, preserving the active language automatically.
  const lang = getLangFromPath(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );

  return (
    <HelmetProvider>
      <Router basename={basenameFor(lang)}>
        <Routing />
      </Router>
    </HelmetProvider>
  );
}
